// node_modules
import axios, { AxiosResponse } from "axios";

export class WikipediaController {
    // TODO: ask Guillaume how we could one do X requests per second

    public async getDescriptionAsync(name: string): Promise<string | undefined> {
        const axiosClient = axios.create();
        delete axiosClient.defaults.headers.common["RequestVerificationToken"];
        
        const response: AxiosResponse<any> = await axiosClient.get("https://en.wikipedia.org/w/api.php", {
            params: {
                "action": "query",
                "list": "search",
                "format": "json",
                "origin": "*",
                "srlimit": 1,
                "srsearch": `intitle: ${name}`
            }
        });
        
        const searchResults = response.data["query"]["search"];
        if (searchResults.length === 0) return undefined;
        const pageId = searchResults[0]["pageid"];

        const descriptionResponse: AxiosResponse<any> = await axiosClient.get("https://en.wikipedia.org/w/api.php", {
            params: {
                "action": "query",
                "format": "json",
                "origin": "*",
                "prop": "extracts",
                "exsentences": 6,
                "explaintext": 1,
                "pageids": pageId
            }
        });
        //await fetch(`https://en.wikipedia.org/w/api.php?action=query&format=json&origin=*&prop=extracts&exsentences=6&explaintext=1&pageids=${pageId}`);
        return descriptionResponse.data["query"]["pages"][pageId]["extract"];;
    }
}

export const WikipediaControllerSingleton = new WikipediaController();